// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__ngpZc","size-small":"Card_size-small____kgC"};